import type { LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  messages: LocaleMessages;
  serverConfig: ServerConfig<'guest'>;
}

const getPasswordRequirementsString = ({ messages, serverConfig }: Params) => {
  const {
    // These attributes are not actually mapped in the getServerConfig
    // api function, and their defaults are set to false. Right now, however,
    // we are effectively always setting them to true if the below handling
    // TODO: What should actually be done here?
    // passwordDisallowEmail = true,
    // passwordDisallowUsername = true,
    passwordDisallowWeakPasswords,
    passwordMaximumLength,
    passwordMinimumLength,
    passwordPreventFiveLastPasswords,
    passwordRequireLettersAndNumeral
  } = serverConfig;

  const passwordDisallowEmail = true;
  const passwordDisallowUsername = true;

  const requirements: string[] = [];

  if (passwordMinimumLength) {
    requirements.push(
      `${messages.authPasswordLength} ${passwordMinimumLength} ` +
        messages.authPasswordLengthCharacters
    );
  }

  if (passwordMaximumLength) {
    requirements.push(
      `${messages.authPasswordLengthNoMoreThan} ${passwordMaximumLength} ` +
        messages.authPasswordLengthCharacters
    );
  }

  if (passwordRequireLettersAndNumeral) {
    requirements.push(messages.authPasswordLettersAndNumeral);
  }

  if (passwordDisallowEmail) {
    requirements.push(messages.authPasswordEmail);
  }

  if (passwordDisallowUsername) {
    requirements.push(messages.authPasswordUsername);
  }

  if (passwordDisallowWeakPasswords) {
    requirements.push(messages.authPasswordStrength);
  }

  if (passwordPreventFiveLastPasswords) {
    requirements.push(messages.authPasswordPreventFiveLast);
  }

  let str = requirements.join(', ');
  if (str && str.length) {
    str = str[0].toUpperCase() + str.substring(1);
  }

  return str;
};

export default getPasswordRequirementsString;
